import { Action, createReducer, on } from "@ngrx/store";
import { RolePricingSchemeLinkActions } from "../actions";
import {
  initialState,
  RolePricingSchemeLinkState,
} from "../states/role-pricing-scheme-link.states";

export const RolePricingSchemeLinkFeatureKey = "rolePricingSchemeLink";

export const rolePricingSchemeLinkReducer = createReducer(
  initialState,
  on(
    RolePricingSchemeLinkActions.createRolePricingSchemeLinkSuccess,
    (state, action) => ({ ...state, updateAgGrid: true })
  ),
  on(
    RolePricingSchemeLinkActions.updateRolePricingSchemeLinkSuccess,
    (state, action) => ({ ...state, updateAgGrid: true })
  ),
  on(
    RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkSuccess,
    (state, action) => ({ ...state, updateAgGrid: true })
  ),
  on(RolePricingSchemeLinkActions.resetAgGrid, (state, action) => ({
    ...state,
    updateAgGrid: false,
  })),
  on(RolePricingSchemeLinkActions.selectRolePricingSchemeLink, (state, action) => ({
    ...state,
    selectedRolePricingSchemeLink: action.RolePricingSchemeLink,
  }))
);

export function role_pricing_scheme_link_reducer(
  state: RolePricingSchemeLinkState | undefined,
  action: Action
) {
  return rolePricingSchemeLinkReducer(state, action);
}
